import { render, staticRenderFns } from "./noticeInfo.vue?vue&type=template&id=4feca98a&scoped=true&"
import script from "./noticeInfo.vue?vue&type=script&lang=js&"
export * from "./noticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./noticeInfo.vue?vue&type=style&index=0&id=4feca98a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feca98a",
  null
  
)

export default component.exports